import { z } from "zod";

export const requestPaginationSchema = z.object({
  cursor: z.string().optional(),
  size: z.number().optional(),
});

export const responsePaginationSchema = z.object({
  nextCursor: z.string().optional(),
  nextUrl: z.string().optional(),
  prevCursor: z.string().optional(),
  prevUrl: z.string().optional(),
});

export const basePaginatedResponseSchema = z.object({
  links: responsePaginationSchema.optional(),
});

export type RequestPagination = z.infer<typeof requestPaginationSchema>;
export type ResponsePagination = z.infer<typeof responsePaginationSchema>;
export type BasePaginatedResponse = z.infer<typeof basePaginatedResponseSchema>;
